module.exports = __webpack_public_path__ + "static/media/pin_bright_brass.f1de1c99.png";